import up from 'unpoly';

up.compiler('[up-validate]', (el) => {
    el.addEventListener('blur', () => {
        up.validate(el);
    });
});
